import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupOne from "../../components/header-signup-one/component";
import {langRegister} from "../../services/langRegister";
import {dataRegister} from "../../services/dataRegister";
import {BeatLoader} from "react-spinners";
import ErrorHandler from "../../components/error-handler/component";
import {marketRegister} from "../../services/marketRegister";

class SelectMarket extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            market: null,
            markets: [],
            error: false
        };
    };

    componentWillMount() {
        window.scrollTo(0, 0);
        this._updateMarkets();
    };

    _updateMarkets(){
        dataRegister.markets("ae", "en").then((response) => {
            if(!response.errors){
                this.setState({markets: response}, () => {
                    console.log(this.state.markets);
                    this._updateMarket();
                });
            }else{
                this.setState({isLoading: false, error: true});
            }
        }, (error) => {
            this.setState({isLoading: false, error: true});
        });
    }

    _updateMarket(){
        try{
            dataRegister.getIp().then((response) => {
                if(response.country){
                    this._selectIpMarket(response.country.toLowerCase());
                }else{
                    this.setState({isLoading: false});
                }
            }, (error) => {
                this.setState({isLoading: false});
            });
        }catch (e) {
            this.setState({isLoading: false});
        }
    }

    _selectIpMarket(market){
        let exist = false;
        for(let i = 0; i < this.state.markets.length; i++){
            if(market === this.state.markets[i].code){
                exist = true;
                this.props.history.push("/" + this.state.markets[i].code + "/" + this.state.markets[i].default_language);
            }
        }
        if(!exist){
            this.setState({isLoading: false});
        }
    }

    _selectMarket(market){
        this.setState({market: JSON.parse(market)}, () => {
            for(let i = 0; i < this.state.markets.length; i++){
                if(this.state.markets[i].id === this.state.market.id){
                    marketRegister.setMarket(this.state.markets[i].code, this.state.markets[i].default_language);
                    langRegister.set(this.state.markets[i].default_language);
                    this.props.history.push("/" + this.state.markets[i].code + "/" + this.state.markets[i].default_language);
                }
            }
        });
    }

    _renderText(item) {
        return langRegister.get("select-market", item, "en");
    }

    render() {
        return (
            <div>
                {
                    !this.state.isLoading &&
                    <HeaderSignupOne view={"select-market"} props={this.props}/>
                }
                <div className={Styles.container}>
                    {
                        !this.state.isLoading && !this.state.error &&
                        <div className={Styles.subtitleContainer}>
                            <div className={Styles.subtitleContainerText}>
                                <span>{this._renderText("item_1")}</span>
                            </div>
                            <div className={Styles.dropdown}>
                                <select className={Styles.dropdownSelection} value={JSON.stringify({
                                    name: this.state.market ? this.state.market.name : "",
                                    code: this.state.market ? this.state.market.code : "",
                                    id: this.state.market ? this.state.market.id : "",
                                    channels: this.state.market ? this.state.market.channels : "",
                                    default_language: this.state.market ? this.state.market.default_language : "",
                                    languages: this.state.market ? this.state.market.languages : ""
                                })}
                                        onChange={(event) => this._selectMarket(event.target.value)}>
                                    {
                                        !this.state.market &&
                                        <option selected value={null}>{this._renderText("item_3")}</option>
                                    }
                                    {
                                        this.state.markets.map((prop, i) => {
                                            return (
                                                <option key={i} value={JSON.stringify({
                                                    name: prop.name,
                                                    code: prop.title,
                                                    id: prop.id,
                                                    channels: prop.channels,
                                                    default_language: prop.default_language,
                                                    languages: prop.languages
                                                })}>{prop.name}</option>
                                            )
                                        })
                                    }
                                </select>
                                {
                                    this.state.market &&
                                    <div className={Styles.dropdownText}>{this.state.market.name}</div>
                                }
                                {
                                    !this.state.market &&
                                    <div className={Styles.dropdownText}>{this._renderText("item_2")}</div>
                                }
                                <img className={Styles.dropdownArrow}
                                     src={require("../../assets/images/arrow-down.svg")}/>
                            </div>
                        </div>
                    }
                    {
                        this.state.isLoading && !this.state.error &&
                        <div className={Styles.loader}>
                            <BeatLoader size={30} color={'#41CBC7'} loading={true}/>
                        </div>
                    }
                    {
                        !this.state.isLoading && this.state.error &&
                        <div className={Styles.loader}>
                            <ErrorHandler/>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default SelectMarket;


// WEBPACK FOOTER //
// ./src/pages/select-market/component.js